









































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import { pluralize } from '@/utils';
import { ILocation } from '@/models/location';
import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';
import { getLabelInfo } from '@/utils/getLabelInfo';

@Component({
  components: {
    Typography
  }
})
export default class Locations extends Vue {
  @Prop({ default: () => [] }) locations!: ILocation[];
  @Prop() code!: string;
  @Prop() businessId!: string;

  get locationsTag() {
    return `${this.locations.length} ${pluralize(
      this.locations.length,
      'Location'
    )}`;
  }

  getFullAddress(location: ILocation) {
    return getLabelInfo(
      ['address', 'addressAdditional', 'city', 'state', 'zip', 'country'],
      location
    );
  }

  phoneMask(phone?: string) {
    if (!phone) return '--';
    return phone.replace(/^(\d{3})(\d{3})(\d+)$/, '($1) $2-$3');
  }

  onLocationRemoved(locationRemovedId: string) {
    eventBus.$emit('reloadInviteBusinessInfo');
  }

  handleEditLocation(location: ILocation) {
    segmentIo.track('Clicked on Edit Location (Ownership experience)');
    this.editLocation(location);
  }

  editLocation(location: ILocation) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editLocation',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        code: this.code,
        location: location,
        businessId: this.businessId,
        canDeleteLocation: this.locations.length > 1,
        onSuccess: (newData: ILocation) => {
          eventBus.$emit('reloadInviteBusinessInfo');
          this.$notification('Changes saved successfully!', 'success');
        }
      }
    );
  }

  mounted() {
    eventBus.$on('inviteMerchantLocationRemoved', this.onLocationRemoved);
  }

  beforeUnmount() {
    eventBus.$off('inviteMerchantLocationRemoved', this.onLocationRemoved);
  }
}
